import React from 'react';

export const PlusIcon = ({
  width = 13,
  height = 14,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75016 7.54165H7.04183V10.25C7.04183 10.5479 6.79808 10.7916 6.50016 10.7916C6.20225 10.7916 5.9585 10.5479 5.9585 10.25V7.54165H3.25016C2.95225 7.54165 2.7085 7.2979 2.7085 6.99998C2.7085 6.70206 2.95225 6.45831 3.25016 6.45831H5.9585V3.74998C5.9585 3.45206 6.20225 3.20831 6.50016 3.20831C6.79808 3.20831 7.04183 3.45206 7.04183 3.74998V6.45831H9.75016C10.0481 6.45831 10.2918 6.70206 10.2918 6.99998C10.2918 7.2979 10.0481 7.54165 9.75016 7.54165Z"
      fill={color}
    />
  </svg>
);
